/**
 * Firebase SDK init.
 * Uses REACT_APP_FIREBASE_* env vars from .env
 * REACT_APP_AUTH_MEMORY_ONLY=true → login page every refresh (for testing)
 * false or unset → localStorage persistence (session survives refresh)
 */
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, inMemoryPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
if (measurementId) {
  firebaseConfig.measurementId = measurementId;
}

const app = initializeApp(firebaseConfig);
export const firebaseApp = app;
export const auth = getAuth(app);

// Explicitly set persistence based on env var
if (process.env.REACT_APP_AUTH_MEMORY_ONLY === 'true') {
  setPersistence(auth, inMemoryPersistence);
} else {
  // Try localStorage; fallback to in-memory when unsupported (Safari private, iframe, 3rd-party blocked)
  setPersistence(auth, browserLocalPersistence).catch((err) => {
    if (err?.code === 'auth/unsupported-persistence-type' || err?.code === 'auth/operation-not-supported-in-this-environment') {
      return setPersistence(auth, inMemoryPersistence);
    }
    throw err;
  });
}
